// Índice de documentos de la categoría: WhatsApp
import conectar_whatsapp_business_app from './conectar-whatsapp-business-app.js';
import configuracion_whatsapp_cloud from './configuracion-whatsapp-cloud.js';

const whatsappDocs = [
  conectar_whatsapp_business_app,
  configuracion_whatsapp_cloud,
];

export default whatsappDocs;
